import React from 'react';

import QuestionShell from '../QuestionShell';
import useQuestionForm from '../QuestionShell/useQuestionForm';

function Price({
  identifier, pages, info, handleDeleteQuestion, handleDuplicateQuestion, mode,
}) {
  const question = useQuestionForm({ identifier, pages, info });

  return (
    <QuestionShell
      {...question}
      identifier={identifier}
      info={info}
      mode={mode}
      titleKey="task.taskEdition.priceText.title"
      descriptionKey="task.taskEdition.priceText.description"
      handleDeleteQuestion={handleDeleteQuestion}
      handleDuplicateQuestion={handleDuplicateQuestion}
    />
  );
}

export default Price;
